// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2Nfjt","content":"LayoutSettings_content__1Coo8"};